"use client";

import { trackMyBrandsInsightsCardClick } from "@faire/web-api--source/events/myBrands/click/insightsCard";
import { trackMyBrandsInsightsCardView } from "@faire/web-api--source/events/myBrands/view/insightsCard";
import React, { useState } from "react";

import {
  EventOrigin,
  InsightCardElement,
} from "@faire/retailer/features/InsightsFeed/events";

interface IInsightCardContext {
  onBrandClick?: (token: string) => void;
  onProductClick?: (token: string) => void;
  onOverlayClick?: (token: string, ctaLink?: string) => void;
  onVisible?: (token: string) => void;
  containerOrigin?: string;
  mutedBrands?: string[];
  onChangeMute?: (brandToken: string) => void;
}

export const InsightCardContext = React.createContext<IInsightCardContext>({});

export const InsightCardContextProvider: React.FC<
  React.PropsWithChildren<{
    origin?: EventOrigin;
    onCardClick?: (token: string) => void;
  }>
> = (props) => {
  const [mutedBrands, setMutedBrands] = useState<string[]>([]);
  const containerOrigin = props.origin ?? EventOrigin.Unknown;

  const onChangeMute = (brandToken: string | undefined) => {
    if (!brandToken) {
      return;
    }
    setMutedBrands((prev) =>
      prev.includes(brandToken)
        ? prev.filter((token) => token !== brandToken)
        : prev.concat(brandToken)
    );
  };

  const handleCardVisible = (token: string) => {
    trackMyBrandsInsightsCardView(containerOrigin, token);
  };

  const handleCardClick =
    (type: InsightCardElement) => (token: string, ctaLink?: string) => {
      trackMyBrandsInsightsCardClick(containerOrigin, type, ctaLink ?? token);
      props.onCardClick?.(token);
    };

  return (
    <InsightCardContext.Provider
      value={{
        containerOrigin,
        mutedBrands,
        onChangeMute,
        onVisible: handleCardVisible,
        onBrandClick: handleCardClick(InsightCardElement.Brand),
        onProductClick: handleCardClick(InsightCardElement.Product),
        onOverlayClick: handleCardClick(InsightCardElement.Overlay),
      }}
    >
      {props.children}
    </InsightCardContext.Provider>
  );
};
